import {observer} from '@api'
import {ContextMenuItem, useStores} from '@modules'
import {CentricLogo} from '@stores/ui'
import React from 'react'

export const CreateLinkedTabWindowMenuItem = observer(function CreateLinkedTabWindowMenuItem() {
  const {vlp} = useStores()

  if (!DEBUG || !vlp?.hierarchy?.hasVlpHierarchy) return null

  return (<React.Fragment>
    <ContextMenuItem icon={<CentricLogo/>} text='C8 Toolbox'>
      <C8LinkedTabWindowMenuItems/>
    </ContextMenuItem>
  </React.Fragment>)
})

export const C8LinkedTabWindowMenuItems = observer(function C8LinkedTabWindowMenuItems() {
  const {catalog, vlp} = useStores()

  return (<React.Fragment>
    <MerchCollectionProductTargetsMenuItem/>

  </React.Fragment>)
})

export const MerchCollectionProductTargetsMenuItem = observer(function MerchCollectionProductTargetsMenuItem() {
  const {vlp, flexLayout: {create}, catalogTab} = useStores()

  if (!catalogTab || !vlp?.hierarchy?.hasVlpHierarchy) return null

  const {tab} = catalogTab
  return <ContextMenuItem icon='grouped-bar-chart' text='Collection Targets' onClick={() => create.newC8Tab_CollectionTargets({parent: tab})}/>
})


// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexComponents/content-panels/c8-flex-toolbox/C8ContextMenuItems.tsx